import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function CTABanner() {
  return (
    <section 
      data-testid="cta-banner"
      className="relative py-20 md:py-28"
      style={{
        backgroundImage: `url('https://images.unsplash.com/photo-1689264337792-40eb98d9e740?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwyfHxjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwc3Vuc2V0fGVufDB8fHx8MTc3MjIwMjgwMnww&ixlib=rb-4.1.0&q=85&w=1600')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-[#E94560] opacity-90"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="text-center md:text-left">
            <h2 data-testid="cta-headline" className="text-3xl md:text-4xl font-bold text-white mb-4">
              Cerchi risorse o vuoi collaborare?
            </h2>
            <p className="text-white/90 text-lg">
              Parliamone insieme. Ti rispondiamo entro 24 ore.
            </p>
          </div>
          <Link 
            to="/contatti" 
            data-testid="cta-contact-button"
            className="bg-white text-[#E94560] font-bold py-4 px-8 inline-flex items-center gap-2 hover:bg-[#1A1A2E] hover:text-white transition-colors shadow-xl"
          >
            Contattaci
            <ArrowRight size={20} />
          </Link>
        </div>
      </div>
    </section>
  );
}
